import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import TeamSummaryMatchupDataContainer from '@gameday/components/TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import Panel from '@gameday/components/Panel/Panel';
import { PanelScreenWrapper, ScoresCardWrapper, MatchUpCardWrapper } from '../Live.style';
import { liveViewsTypes } from '../../themes/liveViewsTypes';
import { LiveTeamSummaryProps } from '../Live';
import MatchupDataContainer from '../../Matchup/containers/MatchupDataContainer';
const { TWOCOLS } = liveViewsTypes;

const trackingConfig = ['Live', 'TeamSummaryMatchup'];
const PanelWideScreen = ({
    tabs
}) => {
    return (
        <PanelScreenWrapper type={TWOCOLS}>
            <Panel
                trackingId='tablet-left'
                controlOpen={true}
                hideButton={ true }
            >
                {tabs}
            </Panel>
            <ScoresCardWrapper type={TWOCOLS}>
                <TeamSummaryMatchupDataContainer {...LiveTeamSummaryProps} useTri={true} componentName={trackingConfig} />
            </ScoresCardWrapper>
            <MatchUpCardWrapper type={TWOCOLS}>
                <MatchupDataContainer />
            </MatchUpCardWrapper>
        </PanelScreenWrapper>
    );
};

PanelWideScreen.propTypes = {
    tabs: PropTypes.object
};

export default withTheme(PanelWideScreen);
